export const PRODUCT_SORT_KEY = {
  popular: 'popular',
  recent: 'recent',
  low_price: 'low_price',
  high_price: 'high_price',
  review: 'review',
  like: 'like',
  labs_recommend: 'recommend', // ness labs 용 추천상품 정렬 키
};
